import React, { useState } from 'react';
import { Button, Input, Select, Upload, message } from 'antd';
import { UploadOutlined, PlayCircleOutlined, DownloadOutlined } from '@ant-design/icons';

const { Option } = Select;

const TrackMatePage = () => {
  const [file, setFile] = useState(null);
  const [spotMethod, setSpotMethod] = useState('LoG');
  const [trackingMethod, setTrackingMethod] = useState('LAP Tracker');
  const [resultData, setResultData] = useState(null);

  const handleUpload = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} uploaded successfully`);
      setFile(info.file.originFileObj);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} upload failed.`);
    }
  };

  const handleRunTrackMate = () => {
    message.info("🧠 TrackMate analysis started...");
    // TODO: 触发后端脚本 or 远程 SSM 命令
    setTimeout(() => {
      setResultData([
        { id: 1, x: 23.4, y: 41.2, frame: 5 },
        { id: 2, x: 24.0, y: 42.1, frame: 6 },
      ]);
      message.success("✅ TrackMate analysis complete.");
    }, 1500);
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-blue-700 mb-6 border-b pb-2">🧪 TrackMate Analysis</h2>

      {/* 上传图像文件区域 */}
      <div className="bg-white shadow rounded-lg p-4 mb-6 border border-blue-100">
        <h3 className="text-lg font-semibold mb-3 text-blue-800">📂 Upload Input Image</h3>
        <Upload
          name="file"
          showUploadList={false}
          customRequest={({ file, onSuccess }) => setTimeout(() => onSuccess("ok"), 0)}
          onChange={handleUpload}
        >
          <Button icon={<UploadOutlined />}>Click to Upload Image</Button>
        </Upload>
      </div>

      {/* 参数选择区 */}
      <div className="bg-white shadow rounded-lg p-4 mb-6 border border-blue-100">
        <h3 className="text-lg font-semibold mb-3 text-blue-800">⚙️ Parameters</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm mb-1">Spot Detection Method</label>
            <Select value={spotMethod} onChange={setSpotMethod} className="w-full">
              <Option value="LoG">LoG Detector</Option>
              <Option value="DoG">DoG Detector</Option>
              <Option value="Manual">Manual</Option>
            </Select>
          </div>
          <div>
            <label className="block text-sm mb-1">Tracking Algorithm</label>
            <Select value={trackingMethod} onChange={setTrackingMethod} className="w-full">
              <Option value="LAP Tracker">LAP Tracker</Option>
              <Option value="Simple LAP">Simple LAP</Option>
              <Option value="Nearest Neighbor">Nearest Neighbor</Option>
            </Select>
          </div>
        </div>
      </div>

      {/* 操作按钮 */}
      <div className="mb-8">
        <Button type="primary" icon={<PlayCircleOutlined />} onClick={handleRunTrackMate}>
          Run TrackMate
        </Button>
      </div>

      {/* 分析结果区域 */}
      {resultData && (
        <div className="bg-gray-50 shadow-inner rounded-lg p-6 border border-blue-100">
          <h3 className="text-lg font-semibold mb-4 text-blue-800">📈 Trajectory Output</h3>
          <table className="table-auto w-full border-collapse text-sm">
            <thead>
              <tr className="bg-blue-50">
                <th className="border px-2 py-1">ID</th>
                <th className="border px-2 py-1">X</th>
                <th className="border px-2 py-1">Y</th>
                <th className="border px-2 py-1">Frame</th>
              </tr>
            </thead>
            <tbody>
              {resultData.map((row, idx) => (
                <tr key={idx}>
                  <td className="border px-2 py-1">{row.id}</td>
                  <td className="border px-2 py-1">{row.x}</td>
                  <td className="border px-2 py-1">{row.y}</td>
                  <td className="border px-2 py-1">{row.frame}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <Button className="mt-4" icon={<DownloadOutlined />}>
            Download CSV
          </Button>
        </div>
      )}
    </div>
  );
};

export default TrackMatePage;
